import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { clear_storage } from "../../utils/localstorage";
import { queryClient } from "../queryClient";

interface UserState {
  isLoggedIn: boolean;
  token: string | null;
  tokenType: string | null;
  roleType: number | null;
  profileData: Record<string, any>; // Define the type of profileData as needed
}

const initialState: UserState = {
  isLoggedIn: false,
  tokenType: null,
  token: null,
  profileData: {},
  roleType: null,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    auth: (
      state,
      action: PayloadAction<{
        access_token: string;
        tokenType: string;
        profileData: Record<string, any>;
        roleType?: number;
      }>
    ) => {
      state.isLoggedIn = true;
      state.token = `${action.payload.tokenType} ${action.payload.access_token}`;
      state.profileData = action.payload.profileData;
      state.roleType = action.payload.roleType ?? 2;
    },
    logout: () => {
      clear_storage();
      queryClient.clear();
      return initialState;
    },
  },
});

export const userActions = userSlice.actions;

export default userSlice.reducer;
